<style scoped>
	#app{
		background: #1A1D25;
	}
	.content{
		position: relative;
		width: 100%;
		height: 100%;
	}
	.center_bj{
		max-width: 100%;
		max-height: 100%;
		position: absolute;top: 0;left: 0;right: 0;bottom: 0;margin: auto;
	}
	.bottom_bj{
		width: 100%;position: absolute;bottom: 0;left: 0;right: 0;
	}
    input{
       background:none;
       outline:none;
       /* border:none; */
       color: #fff;
       font-size: 22px;
    }
    input::-webkit-input-placeholder {
        font-size: 16px;
    }
</style>
<template>
    <div id="app" >
		<div class="content">
			<div class='logo_top'>
				<div class='date' style="">
					<div>{{ time }}</div>
					<div class='date_txt'>{{ date }}</div>
				</div>
				<div class='version' style="">V{{ version }}</div>
				<img src="../assets/top_bj.png" mode="widthFix" class="top_bj" />
			</div>
			
			<img src="../assets/center_bj.png" mode="heightFix" class="center_bj" />
			<img src="../assets/bottom_bj.png" mode="widthFix" class="bottom_bj" />
			<div class="login_box">
				<div style="text-align: center;">
					<img src="../assets/logo_txt.png" mode="widthFix" class="login_logo" />
				</div>
				<div style="margin-top: 40px;color: #fff;">
					<div class='login_item'>
						<div class="txt">账号</div>
						<div>
							<input type="text" v-model="username" @focus="enter_username=true;username_error=false;" @blur="enter_username=false" placeholder="请输入账号" :class="{'enter':enter_username,'error':username_error}" class='username' />
						</div>
					</div>
					<div class='login_item' style="margin-top: 32px;">
						<div class="txt">密码</div>
						<div>
							<input type="password" v-model="password" @focus="enter_password=true;password_error=false;" @blur="enter_password=false" placeholder="请输入密码" :class="{'enter':enter_password,'error':password_error}" class='password'/>
						</div>
					</div>
					<div class='login_item' style="margin-top: 32px;">
						<div class="txt">验证码</div>
						<div style="display: flex;align-items: center;">
							<input type="text" v-model="yzm" @focus="enter_yzm=true;yzm_error=false;" @blur="enter_yzm=false" placeholder="请输入验证码" :class="{'enter':enter_yzm,'error':yzm_error}" class="yzm" />
							<div class="yzm_img">
								<img :src="domain+'/create_yzm?'+random" style="width: 100%;height: 100%;" @click="change_yzm()" />
							</div>
						</div>
					</div>
					<div style="margin-top: 32px;">
						<div class='btn_box'>
							<el-button class='login' type="primary" :class="{'click_btn':click_login}" @click="login()" :loading="login_loading">登录</el-button>
							<el-button class='reset' :class="{'click_btn':click_reset}" @click="reset()">重置</el-button>
							<!-- <div class='login' :class="{'click_btn':click_login}" @click="login()" :loading="login_loading">登录</div> -->
							<!-- <div class='reset' :class="{'click_btn':click_reset}" @click="reset()">重置</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                domain:this.$store.state.domain,
				time: '',
				date:'',
				version:this.$store.state.version,
				username:'',
				password:'',
				yzm:'',
				enter_username:false,
				enter_password:false,
				enter_yzm:false,
				click_login:false,
				click_reset:false,
				random:'',
				username_error:false,
				password_error:false,
				yzm_error:false,
                login_loading:false
            };
        },
        created(){
            this.timeRun();
			
			document.onkeydown = (e) => {
                let _key = window.event.keyCode;
                //!this.clickState是防止用户重复点击回车
                if (_key === 13&&!this.clickState) {
                    this.login();
                }
            };
        },
        //方法
        methods: {
            //时间走动
			timeRun() {
				var date = new Date();
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var day = date.getDate();
				var hour = date.getHours();
				var minute = date.getMinutes();
				var second = date.getSeconds();
				//补0操作
				if (month < 10) {
					month = "0" + month;
				}
				if (day < 10) {
					day = "0" + day;
				}
				if (hour < 10) {
					hour = "0" + hour;
				}
				if (minute < 10) {
					minute = "0" + minute;
				}	
				if (second < 10) {
					second = "0" + second;
				}
				this.time = hour + ":" + minute + ":" + second;
				this.date = year + "." + month + "." + day;
				setTimeout(() => {
					this.timeRun();
				}, 1000);
			},
            change_yzm(){
				this.random = Math.random()
			},
			login(){
				this.click_login=false;
				this.$nextTick(function(){
					this.click_login=true;
					setTimeout(()=>{this.click_login=false},300)
				})
				if(this.username.trim()==''){
                    if(this.username_error){
                        this.username_error=false;
                    }
                    
                    this.$nextTick(function(){
                        this.username_error = true;
                        this.$message({
                            message:'请输入账号',
                            type:'error'
                        })
                    })
					return false;
				}
				if(this.password.trim()==''){
                    if(this.password_error){
                        this.password_error=false;
                    }
                    
                    this.$nextTick(function(){
                        this.password_error = true;
                        this.$message({
                            message:'请输入密码',
                            type:'error'
                        })
                    })
					return false;
				}
				if(this.yzm.trim()==''){
                    if(this.yzm_error){
                        this.yzm_error=false;
                    }
                    
                    this.$nextTick(function(){
                        this.yzm_error = true;
                        this.$message({
                            message:'请输入验证码',
                            type:'error'
                        })
                    })
					return false;
				}
				this.login_loading = true;
				
				var _this = this;
                this.$axios.post(
                    this.domain+'/user_login',
                    { 
                        username:this.username,
						password:this.password,
						yzm:this.yzm,
                    }
                ).then(function (res) {
                    _this.login_loading = false;
                    console.log(res)
                    if(res.data.code=='200ok'){
                        _this.$message({
                            message:'登录成功',
                            type:'success'
                        })
                        // 本地存储token
                        localStorage.setItem('token',res.data.token);
                        localStorage.setItem('openid',res.data.openid);
                        //跳转页面,关闭当前页面
                        setTimeout(()=>{
                            _this.$router.push({
                                path:'/'
                            })
                        },100)
                    }else{
                        _this.$message({
                            message:res.data.msg,
                            type:'error'
                        })
                    }
                }).catch(function (error) {
                    _this.login_loading = false;
                    console.log(error);
                    _this.$message.error('网络异常,数据请求失败')
                })
			},
			reset(){
				this.click_login=false;
				this.$nextTick(function(){
					this.click_reset=true;
					setTimeout(()=>{this.click_reset=false},300)
				})
				this.username=''
				this.password=''
				this.yzm=''
				this.$message({
					message:'重置成功',
					type:'success'
				})
			},
        },
    }
</script>

<style>
	.login_box{
		position: absolute;width: 540px;height: fit-content;top: 0;bottom: 120px;left: 0;right: 110px;margin: auto;
	}
	.login_logo{
		width: 183px;margin-left: 110px;
	}
	.login_item{
		display: flex;align-items: center;justify-content: center;
	}
	.txt{
		text-align: right;color: #fff;font-size: 20px;margin-right: 24px;width: 110px;
	}
	.username,.password{
		width: 354px;height: 64px;border: 1px solid rgba(255,255,255,0.2);border-radius: 10px;padding: 0 23px;
	}
	.yzm{
		width: 194px;height: 64px;border: 1px solid rgba(255,255,255,0.2);border-radius: 10px;padding: 0 23px;
	}
	.yzm_img{
		width: 144px;height: 64px;border-radius: 10px;margin-left: 16px;background: #fff;overflow: hidden;
	}
	.enter{
		border: 1px solid #3271EA !important;
	}
	.btn_box{
		display: flex;
		align-items: center;
		margin-left: 134px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}
	.login{
		width: 184px;
		height: 64px;
		background: #3271EA;
		border-radius: 8px !important;
		margin-right: 32px!important;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
        font-size: 18px !important;;
	}
	.reset{
		width: 184px;
		height: 64px;
		background: rgba(50,113,234,0) !important;
		border: 2px solid #3271EA !important;
		border-radius: 8px !important;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		cursor: pointer;
        font-size: 18px !important;;
        color: #3271EA!important;
	}
	.login.click_btn,.reset.click_btn{
		/* animation: warning 500ms ease; */
		animation: click_btn 300ms ease;
	}
	.error{
		transition: 300ms;
		animation: warning 500ms ease;
		border: 1px solid #ff6767;
	}
	
	@keyframes click_btn{
		0%{
			transform: scale(0.9);
		}
		33%{
			transform: scale(1.05);
		}
		66%{
			transform: scale(0.95);
		}
		100%{
			transform: scale(1);
		}
	}
	@keyframes warning{
		0%{
			transform: translateX(-10px);
		}
		20%{
			transform: translateX(10px);
		}
		40%{
			transform: translateX(-5px);
		}
		60%{
			transform: translateX(5px);
		}
		100%{
			transform: translateX(0px);
		}
	}
</style>
